import React from "react";
import { Container, Wrapper } from "./styles";
import { IoLogoWhatsapp } from "react-icons/io";

export default function Footer() {
	const whatsappMessage = encodeURIComponent(
		"Oii tudo bem? Quero agendar minha análise"
	);

	const whatsappLink = `https://wa.me/5541984146397?text=${whatsappMessage}%21`;

	return (
		<Container>
			<Wrapper>
				<div className="col">
					<ul>
						<li>
							<a href="/quemsomos#priscila">Profa. Dra. Priscila Dabaghi </a>
						</li>
						<li>
							<a href="/quemsomos#zair">Prof. Dr. Zair Candido</a>
						</li>
						<li>
							<a href="/produtos">Nossos produtos</a>
						</li>
						<li>
							<a href="/blog">Fique por dentro das novidades</a>
						</li>
					</ul>
				</div>
				<div className="col">
					<ul>
						<li>
							<h3>Contato:</h3>
							<p>
								E-mail:
								<a href="mailto: dnaforperformance@dnaforperformance.com.br">
									dnaforperformance@dnaforperformance.com.br
								</a>
							</p>
							<p>
								Whatsapp:
								<a href={whatsappLink} target="_blank" rel="noreferrer">
									+55 (41) 9 8414-6397
								</a>
							</p>
							<p>
								Instagram:
								<a href="https://www.instagram.com/dnaforperformance/">
									@dnaforperformance
								</a>
							</p>
						</li>
						<li>
							<h3>Endereço:</h3>
							<p>
								Universidade Positivo <br />
								Pedro Viriato Parigot de Souza 5300 <br /> Bloco Vermelho –
								Espaço Ecohub
							</p>
						</li>
					</ul>
				</div>
				<div className="float-btn">
					<a
						href={whatsappLink}
						target="_blank"
						rel="noreferrer"
						className="whatsapp"
						title="Agende sua analise">
						<IoLogoWhatsapp size={30} color="white" />
					</a>
				</div>
			</Wrapper>
		</Container>
	);
}
